import React from 'react';
import { Routing } from 'services/action';
import { useDispatch } from 'react-redux';
import _ from 'underscore';

import { durationFormat } from 'utilities/common';

const initialState = {
  weight: 0,
  quantity: 0,
  distance: 0,
  travelingTime: 0,
};

export const SectionSummary = ({ manifest, routes, isLoading }) => {
  const Dispatch = useDispatch();

  const [{ weight, quantity, distance, travelingTime }, setState] =
    React.useState(initialState);

  const $onLoad = async () => {
    const req = await Dispatch(Routing.$manifest(manifest?.id));

    if (req?.message === 'success') {
      return req?.data;
    }
  };

  React.useEffect(async () => {
    if (!manifest) return;

    const rt = await $onLoad();

    let tt = null;
    let ds = null;
    let lg = 0;

    if (manifest?.status === 'completed') {
      tt = rt?.actual?.run_time;
      ds = rt?.actual?.distances;
      lg = rt?.actual?.legs?.lenght;
    } else {
      tt = rt?.planning?.run_time;
      ds = rt?.planning?.distances;
      lg = rt?.planning?.legs?.lenght;
    }

    let tw = _.reduce(
      manifest?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_weight;
        }
        return sum;
      },
      0
    );

    let tq = _.reduce(
      manifest?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_quantity;
        }
        return sum;
      },
      0
    );

    setState((prevState) => ({
      ...prevState,
      weight: tw,
      quantity: tq,
      travelingTime: tt,
      distance: ds,
      route: lg,
    }));
  }, [manifest]);

  return (
    <div className="p-0 p-md-3 pb-0 mt-3 mt-md-0">
      <div className="row">
        {manifest?.type !== 'forwarder' && (
          <>
            <div className="col-6 col-md-3 mb-2 mb-md-0">
              <div className="rounded-2 border bg-light-lt text-center p-2">
                <div className="fs-5 fw-semibold text-left text-secondary">
                  {distance?.text || 0}
                </div>
                <div className="page-pretitle text-secondary">Jarak Tempuh</div>
              </div>
            </div>
            <div className="col-6 col-md-3 mb-2 mb-md-0">
              <div className="rounded-2 border bg-light-lt text-center p-2">
                <div className="fs-5 fw-semibold text-left text-secondary">
                  {durationFormat(travelingTime?.value) || 0}
                </div>
                <div className="page-pretitle text-secondary">
                  Estimasi Waktu Tempuh
                </div>
              </div>
            </div>
          </>
        )}

        <div className={`col-6 col-md-3 mb-2 mb-md-0 ${manifest?.type === 'forwarder' ? 'col-md-6': ''}`}>
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {quantity || 0}
            </div>
            <div className="page-pretitle text-secondary">Jumlah Koli</div>
          </div>
        </div>
        <div className={`col-6 col-md-3 mb-2 mb-md-0 ${manifest?.type === 'forwarder' ? 'col-md-6': ''}`}>
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {weight || 0} Kg
            </div>
            <div className="page-pretitle text-secondary">Total Berat</div>
          </div>
        </div>
      </div>
    </div>
  );
};
